import RFFInputField from '../../form/RFFInputField';
import RFFSelectField from '../../form/RFFSelectField';
import RFFIntegerField from '../../form/RFFIntegerField';
import RFFDecimalField from '../../form/RFFDecimalField';



import {
  required,
  isNSNorNIIN,
  minValue,
} from '../../../utils/validationUtils';


export default [
  {
    id: 'partNum',
    name: 'partNum',
    label: 'Part No',
    placeholder: 'Required Field',
    component: RFFInputField,
    isRequired: true,
    validate: required,
    disabled: true,
  },
  {
    id: 'niin',
    name: 'niin',
    label: 'NIIN',
    placeholder: 'NIIN ( Last 9 digits of the NSN)',
    component: RFFInputField,
    isRequired: true,
    validate: isNSNorNIIN,
    maxlength: 128,
    disabled: true,
  },
  {
    id: 'description',
    name: 'description',
    label: 'Description',
    placeholder: 'optional',
    component: RFFInputField,
    maxlength: 50,
  },
  {
    id: 'price',
    name: 'price',
    label: 'Price',
    placeholder: '',
    component: RFFDecimalField,
    isRequired: true,
    validate: minValue(0),
    maxlength: 50,
  },
  {
    id: 'ui',
    name: 'ui',
    label: 'UI',
    isRequired: true,
    component: RFFSelectField,
    // placeholder: 'ui',
  },
  {
    id: 'qup',
    name: 'qup',
    label: 'QUP',
    isRequired: true,
    component: RFFSelectField,
    // placeholder: 'QUP',
  },
  {
    id: 'soh',
    name: 'soh',
    label: 'SOH',
    placeholder: '',
    isRequired: true,
    validate: minValue(0),
    component: RFFIntegerField,
    maxlength: 50,
  },
  {
    id: 'visibility',
    name: 'visibility',
    label: 'Visibility',
    isRequired: true,
    component: RFFSelectField,
    // placeholder: 'visibility',
  },
];



// WEBPACK FOOTER //
// ./src/components/forms/AddInventoryForm/formConfig.jsx